import { useEffect, useRef } from 'react';

/**
 * Ruft callback automatisch alle `ms` Millisekunden auf.
 * Pausiert automatisch, wenn der User ein Input/Textarea/Select fokussiert hat.
 * Kann zusätzlich manuell mit `paused` pausiert werden.
 */
export default function useAutoRefresh(callback, ms = 15000, paused = false) {
    const ref = useRef(callback);
    useEffect(() => { ref.current = callback; });
    useEffect(() => {
        if (paused) return;
        const id = setInterval(() => {
            const active = document.activeElement;
            const isTyping = active && (
                active.tagName === 'INPUT' ||
                active.tagName === 'TEXTAREA' ||
                active.tagName === 'SELECT' ||
                active.isContentEditable
            );
            if (!isTyping) ref.current();
        }, ms);
        return () => clearInterval(id);
    }, [ms, paused]);
}
